import { types, isType } from "mobx-state-tree"
import { getOraclePeriodLength } from "../../src/contract/Admin"
import { getOracleStatus as getOracleStatusContract } from "../../src/contract/OracleVerifier"
import { getAllowance } from '../../src/contract/Token'
import { getMinOracleStake as getContractMinOracleStake } from "../contract/Admin"
import { getUnlockedEthBalance } from "../contract/Rewards";
const mvuMultiplier = 100000;

const AdminStoreModel = types
    .model('AdminStore', {
        singleEventViewActive: types.boolean,
        loading: types.boolean,
        loaded: types.boolean,
        eventCrumbs: types.string,
        oraclePeriod: types.number,
        oracleStatus: types.boolean,
        mvuAllowance: types.number,
        minOracleStake: types.optional(types.number, 0.01),
        unlockedEthBalance: types.optional(types.number, 0),
        actionAttemptedNoWeb3: types.boolean,
        diceRolling: types.boolean,
        coinFlipping: types.boolean
    })
    .views(self => {
        return {
            isLoaded: () => self.loaded,
            isLoading: () => self.loading
        }
    })
    .actions(self => {
        return {
            actionAttemptedWithoutWeb3: async () => {
                self.actionAttemptedNoWeb3 = true;

            },
            closeNoWeb3Modal: async () => {
                self.actionAttemptedNoWeb3 = false;

            },
            getOraclePeriod: async () => {
                getOraclePeriodLength().then((period) => {
                    self.setOraclePeriod(period);
                });
            },
            getOracleStatus: async () => {
                // console.log("beginning get oracle status");
                getOracleStatusContract().then((verified) => {
                    //  console.log("found verified = " + verified);
                    self.setOracleStatus(verified);
                });
            },
            getMvuAllowance: async () => {
                getAllowance().then((allowance) => {
                    self.setMvuAllowance(allowance / mvuMultiplier)
                });

            },
            getContractEthBalance: async () => {
                getUnlockedEthBalance().then((balance) => {
                    self.setUnlockedEthBalance(Number(balance))
                });

            },
            getMinOracleStake: async () => {
                getContractMinOracleStake().then((stake) => {
                    self.setMinOracleStake(stake);
                });
            },
            setUnlockedEthBalance: async (balance) => {
                self.unlockedEthBalance = balance;
            },
            setMinOracleStake: async (stake) => {
                self.minOracleStake = Number(stake) / mvuMultiplier;
            },
            setMvuAllowance: (allowance) => {
                self.mvuAllowance = allowance;

            },
            setOracleStatus: (verified) => {
                (verified ? self.oracleStatus = true : self.oracleStatus = false);

            },
            setOraclePeriod: (period) => {
                self.oraclePeriod = Number(period);
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            setDiceRolling: (rolling) => {
                self.diceRolling = rolling;
            },
            setCoinFlipping: (flipping) => {
                self.coinFlipping = flipping;
            },
            setSingleEventView: (isActive) => {
                self.singleEventViewActive = isActive;
            },
            setEventCrumbs: (crumbText)  => {
                self.eventCrumbs= crumbText;
            }
        }
    });

const AdminStore = AdminStoreModel.create({
    eventCrumbs: "",
    loaded: false,
    loading: false,
    singleEventViewActive: false,
    oraclePeriod: 600,
    oracleStatus: false,
    mvuAllowance: 0,
    actionAttemptedNoWeb3: false,
    diceRolling: false,
    coinFlipping: false
});

export default AdminStore;


// WEBPACK FOOTER //
// ./src/stores/AdminStore.js